import { useResumeStore } from "@/client/stores/resume";

/**
 * Single source of truth for "the job this resume is being tailored to".
 *
 * The target job lives on the resume record as top-level fields
 * (jobCompanyName / jobTitle / jobDescription). Every AI feature — JD
 * suggestions, ATS check, and inline field assistance — should read its job
 * context through this hook instead of reaching into the resume store directly,
 * so context stays consistent across the whole editing experience.
 */

// A job description shorter than this is treated as "not really set" — it isn't
// enough signal for the AI to tailor against.
const MIN_JD_LENGTH = 10;

export type TargetJob = {
  jobCompanyName: string;
  jobTitle: string;
  jobDescription: string;
  hasTargetJob: boolean;
};

export const useTargetJob = () => {
  const jobCompanyName = useResumeStore((state) => state.resume.jobCompanyName ?? "");
  const jobTitle = useResumeStore((state) => state.resume.jobTitle ?? "");
  const jobDescription = useResumeStore((state) => state.resume.jobDescription ?? "");
  const setTargetJob = useResumeStore((state) => state.setTargetJob);

  const hasTargetJob = jobDescription.trim().length > MIN_JD_LENGTH;

  return { jobCompanyName, jobTitle, jobDescription, hasTargetJob, setTargetJob };
};
